import "./Planet.modules.scss";

import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { convertToClass, isPortrait } from "../../assets/javascript/utils";
import { setActivePlanet } from "../../redux/actions";

// * Documentation: https://github.com/greensock/GSAP
import gsap from "gsap";

class Planet extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.planetRef = React.createRef();
  }

  componentDidMount() {
    const { index } = this.props;

    setTimeout(() => {
      gsap.to(this.planetRef.current, {
        opacity: 1,
        duration: 1,
        scale: 1,
        ease: "expo.out",
        delay: 0.1 * index,
      });
    }, 1000);
  }

  onClickPlanet(index) {
    this.props.actions.onSetPlanetActive(index);
  }

  render() {
    const { index, activePlanet, data, multiplier } = this.props;

    return (
      <button
        ref={this.planetRef}
        type="button"
        className={`planet -${convertToClass(data.name)}`}
        style={{
          height: isPortrait() ? data.size : 45,
          top: isPortrait() ? data.x * multiplier - data.size / 2 : 1,
          left: isPortrait() ? "auto" : data.x * multiplier - 30,
        }}
        onClick={() => {
          this.onClickPlanet(index);
        }}>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 162.4 162.4"
          style={{
            enableBackground: "new 0 0 162.4 162.4",
            fill:
              activePlanet === index
                ? data.colour
                : activePlanet === -1
                ? "#fff"
                : "#2e2d33",
            height: data.size,
            width: data.size,
          }}>
          <circle cx="79.4" cy="80.4" r="62.8" />

          {data.hasRing ? (
            <ellipse
              transform="matrix(0.7071 -0.7071 0.7071 0.7071 -33.6338 81.1991)"
              cx="81.2"
              cy="81.2"
              rx="102.8"
              ry="34.6"
              fill="none"
              stroke={
                activePlanet === index
                  ? data.colour
                  : activePlanet === -1
                  ? "#fff"
                  : "#2e2d33"
              }
              strokeWidth="9"
              strokeMiterlimit="10"
            />
          ) : null}
        </svg>
        <span>{data.name}</span>
      </button>
    );
  }
}

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      onSetPlanetActive: bindActionCreators(setActivePlanet, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Planet);
